import { render, staticRenderFns } from "./ProductBundleForm.vue?vue&type=template&id=3f9a8453&"
import script from "./ProductBundleForm.vue?vue&type=script&lang=js&"
export * from "./ProductBundleForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductBundleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports